export const itGoldbet = {
  modal: {
    geolocation: {
      content: 'Goldbet.it sta per chiederti di accedere alla tua posizione per una migliore fruizione del servizio.',
      title: 'Geolocalizzazione Goldbet',
    },
  },
  namespaceTest: 'Ciao goldbet',
};
